import { useFocusEffect } from "expo-router";
import { useCallback, useRef } from "react";

/**
 * Runs a navigation at most once until the calling screen is focused again.
 * A screen stays mounted while a route is pushed over it, so an unguarded CTA
 * pushes one history entry per tap.
 */
export const useSingleFlightNavigation = () => {
	const navigatedRef = useRef(false);

	useFocusEffect(
		useCallback(() => {
			navigatedRef.current = false;
		}, []),
	);

	return useCallback((navigate: () => void) => {
		if (navigatedRef.current) {
			return;
		}
		navigatedRef.current = true;
		navigate();
	}, []);
};
